import classNames from "classnames";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import styles from "./style.module.scss";

interface RichTextEditorProps {
  value?: string | any;
  onChange?: (value: string) => void;
  placeholder?: string;
  formats?: string[];
  modules?: object;
  label?: string;
  required?: boolean;
  error?: string | any;
}

const defaultFormats = [
  "header",
  "font",
  "size",
  "bold",
  "italic",
  "underline",
  "strike",
  "blockquote",
  "list",
  "bullet",
  "indent",
  "link",
  "image",
];

const defaultModules = {
  toolbar: [
    [{ header: "1" }, { header: "2" }, { font: [] }],
    [{ size: [] }],
    ["bold", "italic", "underline", "strike", "blockquote"],
    [
      { list: "ordered" },
      { list: "bullet" },
      { indent: "-1" },
      { indent: "+1" },
    ],
    ["link", "image"],
    ["clean"],
  ],
};

const CustomTextEditor = ({
  value,
  label,
  required = false,
  onChange,
  placeholder = "Enter text here...",
  formats = defaultFormats,
  modules = defaultModules,
  error,
}: RichTextEditorProps) => {
  const handleEditorChange = (content: string) => {
    if (onChange) {
      onChange(content); // Pass the updated value to the parent
    }
  };

  return (
    <div>
      {label && (
        <label className="label">
          {label}
          {required && <span className="asterik">*</span>}
        </label>
      )}
      <div className="mt-1.5">
        <ReactQuill
          value={value || ""}
          onChange={handleEditorChange}
          placeholder={placeholder}
          formats={formats}
          modules={modules}
        />
      </div>
      {!!error && <div className={classNames(styles.error)}>{error}</div>}
    </div>
  );
};

export default CustomTextEditor;
